import { Box } from "@chakra-ui/react";
import { YouthKidSearch } from "../youth-kid/YouthKidSearch";

export const YouthKidsPanel = () => {
  return (
    <Box width={"100%"} minHeight={8}>
      <YouthKidSearch manageYouthKidButtons={true} />
    </Box>
  );
};
